'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Assert = require('../utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _ExtensionAction = require('../ExtensionAction');

var _ExtensionAction2 = _interopRequireDefault(_ExtensionAction);

var _Extension = require('../Extension');

var _Extension2 = _interopRequireDefault(_Extension);

var _Plugin = require('../Plugin');

var _Plugin2 = _interopRequireDefault(_Plugin);

var _Framework = require('../core/Framework');

var _Framework2 = _interopRequireDefault(_Framework);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 扩展管理器
 * 
 * @ignore
 * @export
 * @class ExtensionManager
 */
var ExtensionManager = function () {
    /**
     * 创建一个扩展管理器
     * 
     * @ignore
     * @param {Framework} framework 框架实例
     * @memberof ExtensionManager
     */
    function ExtensionManager(framework) {
        (0, _classCallCheck3.default)(this, ExtensionManager);

        _Assert2.default.notNull('framework', framework);
        this.framework = framework;
        /**
         * @type {Map.<string, Set.<Extension>>}
         */
        this.extensions = new _map2.default();

        this.dispose = this.dispose.bind(this);

        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        this.removeByOwner = this.removeByOwner.bind(this);
        this.find = this.find.bind(this);
    }

    /**
     * 清理资源
     * 
     * @memberof ExtensionManager
     */


    (0, _createClass3.default)(ExtensionManager, [{
        key: 'dispose',
        value: function dispose() {
            this.extensions.clear();
        }

        /**
         * 注册扩展
         * 
         * @param {Extension} extension 扩展对象
         * @memberof ExtensionManager
         */

    }, {
        key: 'add',
        value: function add(extension) {
            _Assert2.default.notNull('extension', extension);
            if (!this.extensions.has(extension.id)) {
                this.extensions.set(extension.id, new _set2.default());
            }
            this.extensions.get(extension.id).add(extension);

            this.framework.eventManager.fireExtensionChanged(extension, _ExtensionAction2.default.ADDED);
        }

        /**
         * 删除扩展
         * 
         * @param {Extension} extension 扩展对象
         * @memberof ExtensionManager
         */

    }, {
        key: 'remove',
        value: function remove(extension) {
            _Assert2.default.notNull('extension', extension);
            if (!this.extensions.has(extension.id)) {
                return;
            }

            var extensionSet = this.extensions.get(extension.id);
            if (!extensionSet.has(extension)) {
                return;
            }

            extensionSet.delete(extension);
            this.framework.eventManager.fireExtensionChanged(extension, _ExtensionAction2.default.REMOVED);
        }

        /**
         * 删除插件拥有的所有插件
         * 
         * @param {Plugin} owner 用于扩展的插件
         * @memberof ExtensionManager
         */

    }, {
        key: 'removeByOwner',
        value: function removeByOwner(owner) {
            _Assert2.default.notNull('owner', owner);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.extensions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pair = _step.value;

                    var extensionSet = pair[1];
                    var removedExtensions = [];
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = (0, _getIterator3.default)(extensionSet), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var extension = _step2.value;

                            if (extension.owner.id === owner.id) {
                                removedExtensions.push(extension);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = (0, _getIterator3.default)(removedExtensions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var removedExtension = _step3.value;

                            extensionSet.delete(removedExtension);
                            this.framework.eventManager.fireExtensionChanged(removedExtension, _ExtensionAction2.default.REMOVED);
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * 根据Id查找注册的所有扩展
         * 
         * @param {string} id 扩展Id
         * @returns {Set.<Extension>} 扩展集合
         * @memberof ExtensionManager
         */

    }, {
        key: 'find',
        value: function find(id) {
            _Assert2.default.notEmpty('extensionId', id);
            if (!this.extensions.has(id)) {
                return new _set2.default();
            }

            return this.extensions.get(id);
        }
    }]);
    return ExtensionManager;
}();

exports.default = ExtensionManager;
//# sourceMappingURL=ExtensionManager.js.map